import { InputTextarea } from "primereact/inputtextarea";

import { FormField } from "@/ds";
import { JUSTIFICATIVA_LABEL, JUSTIFICATIVA_MAX } from "./justificativa-field.constants";
import styles from "./justificativa-field.module.scss";
import type { JustificativaFieldProps } from "./types-justificativa-field";

export function JustificativaFieldView({
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
  rows = 4,
  label = JUSTIFICATIVA_LABEL,
  semAsterisco = false,
  labelClassName,
  testIds,
}: JustificativaFieldProps) {
  return (
    <FormField.Root
      required={!semAsterisco}
      classNames={{ label: labelClassName }}
      error={error}
      disabled={disabled}
    >
      <FormField.Label>{label}</FormField.Label>
      <FormField.Control>
        <InputTextarea
          value={value}
          maxLength={JUSTIFICATIVA_MAX}
          rows={rows}
          onChange={(event) => onChange(event.currentTarget.value)}
          onBlur={onBlur}
          data-testid={testIds.campo}
        />
      </FormField.Control>
      <span className={styles.contador} data-testid={testIds.contador}>
        {value.length}/{JUSTIFICATIVA_MAX}
      </span>
      <FormField.Error data-testid={testIds.erro} />
    </FormField.Root>
  );
}
